import React, { FC, useContext, useEffect, useState } from "react";
import { Dinero } from "dinero.js";
import { MoneyContext } from "../../Providers";

// its a plug to replace library's "convert" with just visual currency change
const changeCurrencyApi = async (
  to: string
): Promise<{ [key: string]: any }> => {
  return {
    rates: {
      [to]: 1,
    },
  };
};

interface Props {
  value: Dinero;
}
const Money: FC<Props> = ({ value }) => {
  const money = useContext(MoneyContext);
  const [result, setResult] = useState<string>("");

  useEffect(() => {
    let on = true;
    const valueCloned = value.setLocale(money.locale);
    const currency = money.currency ?? "EUR";
    valueCloned
      .convert(currency, { endpoint: changeCurrencyApi(currency) })
      .then((val) => {
        if (on) setResult(val.toFormat());
      });
    return () => {
      on = true;
    };
  }, [money, value]);

  return <>{result}</>;
};

export default Money;
